// Group-stage groups/matches endpoints return each player's first_name
// truncated to a single initial (a display-only backend quirk - the "1
// letter + last name" the group table already shows on purpose), so a
// search chip built from someone's full first name never matches against
// those rows. Full names live on the tournament's own players/ listing -
// this fetches it once and keys it by player id so group/match rows can
// resolve the real first name for search matching only, leaving the
// intentional initial display untouched.
export async function fetchPlayerNameMap(api, tournamentId, limit) {
    const map = new Map();
    try {
        let res = await api.get(`/api/v1.0/tournaments/${tournamentId}/players/?limit=${limit}`);
        // `limit` (caller-supplied, usually tournament.player_quantity) is a
        // registration-target/category number, not a reliable count of who's
        // actually registered - a tournament with more real players than
        // that silently truncated this list short of the last ones, so a
        // full-name search chip for anyone past the cutoff (e.g. registered
        // late) never resolved and stayed stuck on the truncated initial.
        // The response's own `count` is the actual total; refetch once with
        // that instead whenever it's bigger than what we got.
        const total = res.data?.count;
        if (total && total > (res.data?.results?.length || 0)) {
            res = await api.get(`/api/v1.0/tournaments/${tournamentId}/players/?limit=${total}`);
        }
        const players = res.data?.results || res.data || [];
        players.forEach(p => {
            const id = p.player_id || p.player || p.id;
            if (id) map.set(id, { first_name: p.first_name, last_name: p.last_name });
        });
    } catch (e) {
        console.error("Failed to fetch player name map:", e);
    }
    return map;
}
